// extracted by mini-css-extract-plugin
export default {"data_container":"TextSettings_data_container__2kuqu"};